import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubSupervisorAuth } from '../../context/SubSupervisorAuthContext';
import { listMyBanks } from '../../api/subSupervisor';
import './SubSupervisorBanksPage.css';

const SubSupervisorBanksPage = () => {
  const { subSupervisor, logout } = useSubSupervisorAuth();
  const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    listMyBanks()
      .then((data) => { if (!cancelled) setBanks(data); })
      .catch(() => { if (!cancelled) setError('Impossible de charger les banks.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/sub-supervisor/login');
  };

  return (
    <div className="ssb-page">
      <div className="ssb-topbar">
        <span className="ssb-brand">CGL — Sous-superviseur</span>
        <div className="ssb-topbar-right">
          {subSupervisor && <span className="ssb-username">{subSupervisor.name}</span>}
          <span className="ssb-logout" onClick={handleLogout}>Deconnexion</span>
        </div>
      </div>

      <div className="ssb-body">
        <h2 className="ssb-title">Mes Banks</h2>

        {error && <p className="ssb-error">{error}</p>}
        {loading ? (
          <p>Chargement...</p>
        ) : (
          <table className="ssb-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>Nom</th>
                <th>Group</th>
                <th>Adresse</th>
                <th>Vente activee</th>
              </tr>
            </thead>
            <tbody>
              {banks.map((bank) => (
                <tr key={bank.id}>
                  <td>{bank.seq}</td>
                  <td>{bank.username || '—'}</td>
                  <td>{bank.name}</td>
                  <td>{bank.group_name || ''}</td>
                  <td>{bank.address}</td>
                  <td>{bank.sale_enabled ? 'Oui' : 'Non'}</td>
                </tr>
              ))}
              {banks.length === 0 && (
                <tr><td colSpan={6} className="ssb-empty">Aucun bank assigne.</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default SubSupervisorBanksPage;
